
import { show, reply } from '@/api/drama_completions'
import { Component, Vue } from 'vue-property-decorator'
import { store, update } from '@/api/original_dramas'

@Component({
  components: {}
})

export default class extends Vue {
  model: Record<string, any> = {}

  loading = false

  rules = {
    reply: [
      { required: false, message: '请输入回复内容', trigger: 'blur' }
    ]
  }

  // validate form
  validateForm (): void {
    const el: any = this.$refs.form
    el.validate((val: boolean) => val && this.sendRequest())
  }

  // send login request
  async sendRequest () {
    this.loading = true
    const params: Record<string, any> = this.model
    try {
      await reply(params.id, params)
      this.$eva.success('Submit the success!')
      this.$router.push({ name: 'drama_completions' })
    } finally {
      this.loading = false
    }
  }

  async created () {
    const { data } = await show(parseInt(this.$route.params.id))
    this.model = data
  }
}
